import React from "react";
import { Deposit } from "../../../../../types/bookings";
import { Check, Ellipsis } from "lucide-react";

export const getPaymentIcon = (deposit: Deposit): React.JSX.Element => {
  let icon: React.JSX.Element;

  if (deposit.status === "paid") {
    icon = (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          width: "32px",
          height: "20px",
          backgroundColor: "rgba(34, 197, 94, 0.15)"
        }}
      >
        <Check className="w-4 h-4 text-green-500" />
      </span>
    );
  } else {
    icon = (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          width: "32px",
          height: "20px",
          backgroundColor: "rgba(168, 85, 247, 0.15)"
        }}
      >
        <Ellipsis className="w-4 h-4 text-purple-500" />
      </span>
    );
  }

  return icon;
};
